import { useEffect, useState } from "react";
import { Copy, FileText } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api } from "@/lib/api";
import { Loader, PageHeader } from "@/components/common";

const ORDER = ["IDEA", "VALIDATE", "BUILD", "REGISTER", "SET UP", "LAUNCH", "GROW"];

export default function Resources() {
  const [list, setList] = useState(null);
  const [open, setOpen] = useState(null);
  useEffect(() => {
    api.get("/templates").then((r) => {
      setList(r.data);
      const h = window.location.hash.slice(1);
      if (h) setOpen(r.data.find((x) => x.id === h) || null);
    });
  }, []);
  if (!list) return <Loader />;
  const copy = () => { navigator.clipboard?.writeText(open.body); toast.success("Copied to clipboard"); };
  return (
    <div data-testid="resources-page">
      <PageHeader eyebrow="Resources" title="Templates for each stage" subtitle="Use them when the journey asks — each one connects to a specific step." />
      <div className="space-y-6">
        {ORDER.filter((s) => list.some((x) => x.stage === s)).map((s) => (
          <section key={s}>
            <div className="sb-eyebrow mb-2">{s}</div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
              {list.filter((x) => x.stage === s).map((x) => (
                <button key={x.id} onClick={() => setOpen(x)} className="sb-card p-4 flex items-center gap-3 text-left hover:shadow-md transition-shadow" data-testid={`template-card-${x.id}`}>
                  <span className="h-10 w-10 rounded-xl bg-[#E8F8F4] flex items-center justify-center"><FileText className="h-5 w-5 text-[#1DB99A]" /></span>
                  <span className="font-semibold text-sm">{x.title}</span>
                </button>
              ))}
            </div>
          </section>
        ))}
      </div>
      <Dialog open={!!open} onOpenChange={(o) => !o && setOpen(null)}>
        <DialogContent className="max-w-lg rounded-3xl bg-[#FBF8F2]" data-testid="template-dialog">
          <DialogHeader><DialogTitle className="font-display text-xl">{open?.title}</DialogTitle></DialogHeader>
          <pre className="whitespace-pre-wrap font-sans text-sm bg-white border border-[#EADEC9] rounded-xl p-4 max-h-[55vh] overflow-y-auto">{open?.body}</pre>
          <button onClick={copy} className="sb-btn-primary w-full" data-testid="template-copy-btn"><Copy className="h-4 w-4" />Copy template</button>
        </DialogContent>
      </Dialog>
    </div>
  );
}
